var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_120_1026",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_120_1026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 8.50004V7.16671H10.6667V8.50004H5.33341ZM5.33341 5.83337V4.50004H10.6667V5.83337H5.33341ZM4.00008 9.83337H9.00008C9.3223 9.83337 9.6223 9.90282 9.90008 10.0417C10.1779 10.1806 10.4112 10.3778 10.6001 10.6334L12.0001 12.4667V3.16671H4.00008V9.83337ZM4.00008 13.8334H11.3667L9.55008 11.45C9.48341 11.3612 9.40286 11.2917 9.30842 11.2417C9.21397 11.1917 9.11119 11.1667 9.00008 11.1667H4.00008V13.8334ZM12.0001 15.1667H4.00008C3.63341 15.1667 3.31953 15.0362 3.05841 14.775C2.7973 14.5139 2.66675 14.2 2.66675 13.8334V3.16671C2.66675 2.80004 2.7973 2.48615 3.05841 2.22504C3.31953 1.96393 3.63341 1.83337 4.00008 1.83337H12.0001C12.3667 1.83337 12.6806 1.96393 12.9417 2.22504C13.2029 2.48615 13.3334 2.80004 13.3334 3.16671V13.8334C13.3334 14.2 13.2029 14.5139 12.9417 14.775C12.6806 15.0362 12.3667 15.1667 12.0001 15.1667Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.1f9034d208c0a131d317c901e755eaca.svg";
export { ForwardRef as ReactComponent };